import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  lineItemRow: {
    padding: theme.spacing(1.5),
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
    cursor: 'pointer',
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    }
  },
  rightAligned: {
    textAlign: 'right'
  },
  rightAlignedMobile: {
    textAlign: 'center',
  },
  editableCell: {
    padding: theme.spacing(0.75),
  },
  centerAligned: {
    display: 'flex',
    alignItems: 'center'
  },
  expandablePanel: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: 0,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1)
    }
  },
  expandablePanelContent: {
    padding: theme.spacing(1),
  },
  countInput: {
    width: '50%',
    '& .MuiInputBase-input': {
      textAlign: 'right',
      padding: theme.spacing(1, 2), // Increased padding for text input
      height: '1.5rem',
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white', // Keeping white background for input field for better contrast
    }
  },
  panelLabel: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5)
  },
  panelValue: {
    fontWeight: 500
  },
}));